document.addEventListener("DOMContentLoaded", () => {

  const slider = document.querySelector(".rxn-product-features-slider");
  const progress = document.querySelector(".rxn-feature-progress-bar");

  if (!slider || !progress) return;

  function updateProgress() {

  const maxScroll = slider.scrollWidth - slider.clientWidth;

  if (maxScroll <= 0) {
    progress.style.width = "100%";
    return;
  }

  const visibleRatio = slider.clientWidth / slider.scrollWidth;
const startWidth = visibleRatio * 100;

const percent =
  startWidth +
  ((slider.scrollLeft / maxScroll) * (100 - startWidth));

  progress.style.width = percent + "%";

}
  updateProgress();

  slider.addEventListener("scroll", updateProgress);

  window.addEventListener("resize", updateProgress);

  /* ---------- Mouse Drag ---------- */

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.classList.add("dragging");
    startX = e.pageX;
    scrollLeft = slider.scrollLeft;
  });

  document.addEventListener("mouseup", () => {
    isDown = false;
    slider.classList.remove("dragging");
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.classList.remove("dragging");
  });

  slider.addEventListener("mousemove", (e) => {

    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX;

    const walk = (x - startX) * 1.4;

    slider.scrollLeft = scrollLeft - walk;

  });

  /* ---------- Mouse Wheel ---------- */

  slider.addEventListener("wheel", (e) => {

    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {

      e.preventDefault();

      slider.scrollLeft += e.deltaY;

    }

  }, { passive: false });

});